import * as Sentry from '@sentry/browser'
import { createStandardAction } from 'typesafe-actions'
import wfeTokenRefresh from '../util/wfeTokenRefresh'
import config from '../config'
import { bindChannelChunking } from '../util/bindChannelChunking'
import { getJwt } from '../util/jwtLocalstorage'
import { ThunkResult } from './types'
import { uploadFailed, uploadSuccess, uploadToS3 } from './upload'

const PUSHER_CONNECTED = 'pusher/PUSHER_CONNECTED'
const PUSHER_DISCONNECTED = 'pusher/PUSHER_DSCONNECTED'

export const keysRequest = () => {
  const jwt = getJwt()
  const WTAI_EXPRESS_URL = config.getWtaiExpressUrl()

  return fetch(WTAI_EXPRESS_URL + '/keys', {
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Cache-Control': 'no-store',
    },
  })
}

export interface KeysResponse {
  channelName: string
  traceId: string
  appKey: string
  cluster: string
}

export const getKeys = async (): Promise<KeysResponse | undefined> => {
  try {
    let response = await keysRequest()

    if (response.status !== 200) {
      await wfeTokenRefresh(response)
      response = await keysRequest()
    }

    return response.json()
  } catch (error) {
    console.error('FAILED TO GET KEYS', error)
  }
}

interface PusherConnectedPayload {
  appKey: string
  cluster: string
  channelName?: string
}

export interface PusherMessage {
  action: 'uploadPaper'
  message?: {
    url?: string
  }
  error?: string | null
}
export const pusherConnected = createStandardAction(PUSHER_CONNECTED)<PusherConnectedPayload>()

export const pusherDisconnected = createStandardAction(PUSHER_DISCONNECTED)()

export const subscribeToChannel = (): ThunkResult<void> => async (dispatch, getState, { pusherClient }) => {
  const state = getState()

  const { channelName } = state.pusher

  if (channelName) {
    if (!pusherClient.uploadChannel) {
      await pusherClient.subscribe(channelName)
    }
    dispatch(uploadToS3)

    if (pusherClient.uploadChannel) {
      bindChannelChunking(pusherClient.uploadChannel, 'uploadPaper', (data: PusherMessage) => {
        const { message, error } = data

        if (error) {
          Sentry.captureMessage(error)
          dispatch(uploadFailed())
        }
        if (message && message.url) {
          dispatch(uploadSuccess(message.url))
        }
      })
    }
  }
}
